<div class="flex h-full w-full min-w-0 max-w-[100vw] flex-col bg-gray-50 overflow-hidden sm:max-w-[min(1100px,100vw-1rem)] lg:max-w-[min(1100px,100vw-2rem)]">
  <div
    class="sticky top-0 z-20 flex flex-col gap-4 border-b bg-white px-4 py-4 sm:flex-row sm:items-center sm:justify-between sm:px-6 sm:py-5 md:px-8 md:py-6 lg:gap-6 xl:gap-8 2xl:gap-10"
  >
    <div class="flex min-w-0 flex-col gap-4 lg:flex-row lg:items-center lg:gap-6 xl:gap-8">
      <h2 class="text-xl font-bold tracking-tight text-gray-800 sm:text-2xl">Estructura Interna</h2>
      <div [formGroup]="form" class="rounded-2xl bg-gray-100 px-3 py-2 sm:px-4">
        <app-toggle-option
          title="Sección Múltiple (Padre)"
          icon="layers"
          iconColor="purple"
          formControlName="multiple"
        ></app-toggle-option>
      </div>
    </div>
    <div class="flex flex-shrink-0 flex-wrap items-center justify-end gap-2 sm:gap-3">
      <button mat-button type="button" (click)="dialogRef.close()">Cancelar</button>
      <button mat-button type="button" class="btn-dialog-soft-primary" (click)="addField()">
        <mat-icon class="mr-2">add_circle</mat-icon>
        Agregar Campo
      </button>
    </div>
  </div>

  <mat-dialog-content class="m-0 flex-1 overflow-y-auto !p-4 sm:!p-6 md:!p-8">
    <form [formGroup]="form" class="w-full">
      <div formArrayName="fields" class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8 w-full">

        <div *ngFor="let field of fields.controls; let i = index" [formGroupName]="i"
          class="flex flex-col p-6 border border-gray-200 rounded-3xl bg-white shadow-sm hover:shadow-md transition-all w-full box-border">

          <div class="flex justify-between items-center mb-4">
            <span class="text-xs font-bold text-gray-400 uppercase tracking-wider">Campo #{{ i + 1 }}</span>
            <button mat-icon-button color="warn" class="bg-red-50 hover:bg-red-100 rounded-full shadow-sm"
              (click)="confirmDelete(i)">
              <mat-icon style="font-size: 20px;">delete_outline</mat-icon>
            </button>
          </div>

          <div class="w-full mb-3">
            <app-toggle-option title="Campo de usuario" icon="error_outline" iconColor="orange"
            formControlName="isUserField"></app-toggle-option>
          </div>

          <div class="w-full mb-3 flex flex-col gap-2" *ngIf="field.get('isUserField').value">
            <mat-form-field class="w-full">
              <mat-label>Categoria</mat-label>
              <mat-select formControlName="userFieldEntity" (selectionChange)="loadAllUsersFields($event.value)">
                <mat-option *ngFor="let opt of userEntityList" [value]="opt.value">{{ opt.label }}</mat-option>
              </mat-select>
            </mat-form-field>

            <div class="flex items-center gap-2">
              <mat-form-field class="flex-auto">
                <mat-label>Campo de Usuario</mat-label>
                <mat-select formControlName="userField">
                  <mat-option *ngFor="let uf of userFieldsConfig" [value]="uf.fieldName">
                    {{ uf.fieldLabel?.master }} - {{ uf.fieldName }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <button
                mat-flat-button
                color="primary"
                type="button"
                class="mb-5 h-[50px] min-w-[100px]"
                (click)="syncField(field)">
                <mat-icon class="mr-1">sync</mat-icon>
              </button>
            </div>
          </div>

          <div class="border-t border-gray-100 my-2"></div>

          <mat-form-field class="w-full mb-1">
            <mat-label>Nombre Campo (DB)</mat-label>
            <input matInput formControlName="fieldName" (blur)="onNameBlur()">
            <mat-error *ngIf="field.get('fieldName').hasError('duplicateName')">
              Este nombre ya está en uso en otro subcampo
            </mat-error>
            <mat-error *ngIf="field.get('fieldName').hasError('required')">
              El nombre es obligatorio
            </mat-error>
          </mat-form-field>

          <mat-form-field class="w-full mb-1">
            <mat-label>Etiqueta (UI)</mat-label>
            <input matInput formControlName="fieldLabel">
            <mat-error *ngIf="field.get('fieldLabel').hasError('required')">
              La etiqueta es obligatoria
            </mat-error>
          </mat-form-field>

          <div class="flex items-center gap-2 mb-3">
            <mat-form-field class="flex-grow">
              <mat-label>Tipo</mat-label>
              <mat-select formControlName="fieldType">
                <mat-option *ngFor="let opt of fieldTypeOptions" [value]="opt.value">{{ opt.label }}</mat-option>
              </mat-select>
            </mat-form-field>

            <button mat-mini-fab color="primary" type="button"
              *ngIf="['select', 'multiselect', 'attachment'].includes(field.get('fieldType').value)"
              (click)="openValuesModal(field)" matTooltip="Configurar Valores/Adjunto">
              <mat-icon>settings</mat-icon>
            </button>
          </div>

          <div class="border-t border-gray-100 my-2"></div>

          <div class="grid grid-cols-2 gap-4 my-3">
            <mat-form-field class="w-full">
              <mat-label>Grupo</mat-label>
              <input matInput formControlName="group">
            </mat-form-field>
            <mat-form-field class="w-full">
              <mat-label>Pos. Grupo</mat-label>
              <input matInput type="number" formControlName="groupPosition">
            </mat-form-field>
          </div>

          <div class="grid grid-cols-2 gap-4 mb-3">
            <mat-form-field class="w-full">
              <mat-label>Icono</mat-label>
              <input matInput formControlName="icon">
            </mat-form-field>
            <mat-form-field class="w-full">
              <mat-label>Color</mat-label>
              <input matInput formControlName="iconColor">
            </mat-form-field>
          </div>

          <div class="grid grid-cols-2 gap-4 mb-4">
            <mat-form-field class="w-full">
              <mat-label>Posición</mat-label>
              <input matInput type="number" formControlName="position">
              <mat-error *ngIf="field.get('position').hasError('duplicatePosition')">
                Posición duplicada en este grupo. (Sugerencia: {{ field.get('position').errors?.lastOccupied + 1 }})
              </mat-error>
            </mat-form-field>

            <mat-form-field class="w-full mb-3">
              <mat-label>Schema</mat-label>
              <input matInput formControlName="schemaMaster" />
            </mat-form-field>

            <ng-container [ngSwitch]="field.get('fieldType').value">
              <ng-container *ngSwitchCase="'multiselect'">
                <mat-form-field *ngIf="!field.get('schemaMaster')?.value">
                  <mat-label>Valores por Defecto (Multiple)</mat-label>
                  <mat-select formControlName="defaultValue" multiple>
                    <mat-option *ngFor="let opt of field.get('valuesData').value" [value]="opt.id">
                      {{ opt.name || opt.label || opt.id }}
                    </mat-option>
                  </mat-select>
                  <mat-hint *ngIf="!field.get('valuesData').value?.length">
                    Configure primero los valores en el botón de ajustes
                  </mat-hint>
                </mat-form-field>

                <app-select-schema
                  *ngIf="field.get('schemaMaster')?.value"
                  [schema]="field.get('schemaMaster')?.value"
                  [form]="field"
                  [isMultiple]="true"
                  [companyId]="data.companyId">
                </app-select-schema>
              </ng-container>

              <ng-container *ngSwitchCase="'select'">
                <mat-form-field *ngIf="!field.get('schemaMaster')?.value">
                  <mat-label>Valor por Defecto</mat-label>
                  <mat-select formControlName="defaultValue">
                    <mat-option [value]="''">Ninguno</mat-option>
                    <mat-option *ngFor="let opt of field.get('valuesData').value" [value]="opt.id">
                      {{ opt.name || opt.label || opt.id }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <app-select-schema
                  *ngIf="field.get('schemaMaster')?.value"
                  [schema]="field.get('schemaMaster')?.value"
                  [form]="field"
                  [isMultiple]="false"
                  [companyId]="data.companyId">
                </app-select-schema>
              </ng-container>


              <!-- DEFAULT -->
              <mat-form-field *ngSwitchDefault>
                <mat-label>Valor Default</mat-label>
                <input matInput formControlName="defaultValue"/>
              </mat-form-field>

            </ng-container>
          </div>

          <div class="grid grid-cols-2 gap-4 mb-4">
            <mat-form-field><mat-label>Campo Padre</mat-label><input matInput
                formControlName="parentFieldName" /></mat-form-field>
          </div>

          <hr class="mb-4 opacity-50">

          <mat-form-field class="w-full mb-3">
            <mat-label>Máximo caracteres</mat-label>
            <input matInput type="text" formControlName="maxLength" min="0" inputmode="numeric" mask="separator.0"
              thousandSeparator="," [dropSpecialCharacters]="false" />
          </mat-form-field>

          <mat-form-field class="w-full mb-3">
            <mat-label>Mínimo caracteres</mat-label>
            <input matInput type="text" formControlName="minLength" min="0" inputmode="numeric" mask="separator.0"
              thousandSeparator="," [dropSpecialCharacters]="false" />
            <mat-error *ngIf="field.get('minLength')?.hasError('minGreaterThanMax')">
              El mínimo no puede ser mayor que el máximo.
            </mat-error>
          </mat-form-field>

          <mat-form-field *ngIf="field.get('fieldType')?.value === 'text'" class="w-full mb-3">
            <mat-label>Conversión de Texto</mat-label>
            <mat-select formControlName="caseConversion">
              <mat-option value="NONE">Ninguno</mat-option>
              <mat-option value="UPPER">Mayúsculas</mat-option>
              <mat-option value="LOWER">Minúsculas</mat-option>
              <mat-option value="TITLE">Capitalizar palabras</mat-option>
              <mat-option value="SENTENCE">Capitalizar primera</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field *ngIf="field.get('fieldType')?.value === 'text'" class="w-full mb-3">
            <mat-label>Máscara de Texto</mat-label>
            <input matInput formControlName="mask" placeholder="Ej. (000) 000-000" />
          </mat-form-field>

          <div class="space-y-2 bg-gray-50 p-4 rounded-2xl border border-dashed border-gray-200">
            <app-toggle-option title="Visible" icon="visibility" iconColor="blue"
              formControlName="isVisible"></app-toggle-option>

            <br>

            <app-toggle-option title="Requerido (UI)" icon="error_outline" iconColor="orange"
              formControlName="isRequired"></app-toggle-option>

            <br>

            <app-toggle-option title="Mandatorio" icon="gavel" iconColor="red"
              formControlName="isTypeMandatory"></app-toggle-option>

            <ng-container *ngIf="field.get('fieldType')?.value === 'text'">
              <br>

              <app-toggle-option title="Eliminar espacios" icon="content_cut" iconColor="green"
                formControlName="trimSpaces"></app-toggle-option>
            </ng-container>
          </div>
        </div>
      </div>
    </form>
  </mat-dialog-content>

  <div class="flex justify-end items-center px-8 py-6 border-t bg-white sticky bottom-0 z-20">
    <button mat-flat-button color="primary" class="px-12 py-3 rounded-xl text-lg font-bold" (click)="save()"
      [disabled]="form.invalid">
      Confirmar Estructura
    </button>
  </div>
</div>
